import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { ClassFilterMapping, ClassFilterMappingType, ClassFilterMatcher } from "./ClassFilterMatcher";

export class DocSearchIndex
{
  items:DocSearchIndexItem[];
}

export class DocSearchIndexItem
{
  title:string;
  _hierarchyName:string;
  link:string;
  icon:string;
  inheritance:Element;
  _inheritanceStrings:string[];

  get hierarchyName():string
  {
    if ( this._hierarchyName )
    {
      return this._hierarchyName;
    }

    if ( this.inheritanceStrings.length === 0 )
    {
      this._hierarchyName = this.title;
    }
    else
    {
      this._hierarchyName = this.inheritanceStrings.join( "." ) + "." + this.title;
    }

    if ( this._hierarchyName.indexOf( "`" ) != -1 )
    {
      // console.log( "Has back tick:", this.title );
    }

    return this._hierarchyName;      

  }
  
  get inheritanceStrings()
  {
    if ( ! this._inheritanceStrings )
    {
      let anchors = ElementType.anchor.queryAll( this.inheritance );
      this._inheritanceStrings = anchors.map( a => a.textContent );

      if ( ! this._inheritanceStrings )
      {
        this._inheritanceStrings = [];
      }
    }

    return this._inheritanceStrings;
  }

  isMatching( filter:ClassFilterMapping )
  {
    let inheritanceMatching = this.isInheritanceMatching( filter.inheritanceMatcher );
    let classMatching = this.isClassMatching( filter.classMatcher );

    
    let result = ClassFilterMappingType.Any === filter.mappingType ? 
                 ( inheritanceMatching || classMatching ) : 
                 ( inheritanceMatching && classMatching );

    return result;
  }

  isClassMatching( matcher:RegExp )
  {
    if ( ! matcher )
    {
      return true;
    }

    return matcher.test( this.title );
  }


  isInheritanceMatching( matcher:RegExp )
  {
    if ( ! matcher )
    {
      return true;
    }

    if ( matcher.test( this.title ) )
    {
      return true;
    }

    if ( this.inheritanceStrings.length === 0 )
    {
      return false;
    }

    let matched = this.inheritanceStrings.find( s => matcher.test( s ) );

    return matched !== undefined;
  }
}
